export default "__VITE_PUBLIC_ASSET__fa828480__"